import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getAllRewardConfigs } from '../../../api/actions/reward-config/reward-config-get-all';
import { AddBreadcrumbsItem } from '../../../components/shared/breadcrumbs/breadcrumbs';
import { Button } from '../../../components/shared/button/button';
import { Grid } from '../../../components/shared/grid/grid';
import { LinkButton } from '../../../components/shared/link-button/link-button';
import { Loader } from '../../../components/shared/loader/loader';
import { compareText } from '../../../helpers/array-helpers';
import { basePerformError } from '../../../helpers/error-helpers';
import { joinPath } from '../../../helpers/path-helpers';
import { IRewardConfig } from '../../../models/reward-config';
import styles from './reward-configs-list.module.scss';

export function RewardConfigsList(props: RouteComponentProps) {
    const [loading, setLoading] = useState(true);
    const [rewardSchemas, setRewardSchemas] = useState<IRewardConfig[]>([]);

    const loadData = React.useCallback(async () => {
        setLoading(true);
        try {
            setRewardSchemas((await getAllRewardConfigs()).sort((el1, el2) => compareText(el1, el2, (el) => el.name)))
        }
        catch(err) {
            basePerformError(err, props.history);
        }
        setLoading(false);
    }, [props.history]);

    useEffect(() => {
        loadData().catch(() =>{/** */});
    }, [loadData]);

    const renderButtons = () => (
        <div className={styles.buttons}>
            <Button className="orange" to={joinPath(props.match.url, '_')}>Add Reward Schema</Button>
        </div>
    );

    return loading ? (<Loader />) : (<>

        <Grid<IRewardConfig>
            getPageData={(page, pageSize) => {
                return Promise.resolve({
                    page,
                    count: rewardSchemas?.length || 0,
                    data: rewardSchemas?.slice(pageSize * (page - 1), pageSize * page),
                });
            }}

            containerRenderer={(content, pager) => (<>
                <div className={styles.pager}>{pager} {renderButtons()}</div>
                <table cellPadding="0" cellSpacing="0" className={`list ${styles.list}`}>
                    <tbody>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                        {content}
                    </tbody>
                </table>
                <div className={styles.pager}>{pager}</div>
            </>)}

            itemRenderer={(item, i) => (
                <tr key={item.uid}>
                    <td>
                        {i + 1}
                    </td>
                    <td>
                        {item.name}
                    </td>
                    <td>
                        {item.description}
                    </td>
                    <td>
                        <LinkButton to={joinPath(props.match.url, item.uid)}>
                            <FontAwesomeIcon icon={faEdit} /> Edit
                        </LinkButton><br />
                    </td>
                </tr>
            )}
        />

        {renderButtons()}
    </>);
}